import React, { useState } from "react";

import Button from "../components/Button/Button";
import InputTextSlide from "../components/InputTextSlide/InputTextSlide";
import Header from "../elements/Header/Header";
import Loading from "../elements/LoadingScreen/Loading";
import "../Slideshow/Slideshow.css";
import "./pixelGenerator.css";
import {
  PIXEL_ACCEPT,
  PIXEL_INITIAL_FORM,
  submitPixelGeneration,
} from "./pixelGeneratorController";

const PixelGenerator = () => {
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState(PIXEL_INITIAL_FORM);
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [infoType, setInfoType] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    await submitPixelGeneration({
      file,
      formData,
      setLoading,
      setInfo,
      setInfoType,
    });
  };

  return (
    <>
      <Header />
      {loading ? <Loading info="Prosze czekac, plik jest przetwarzany..." /> : null}
      <div className="slideshow pixel-generator">
        <form className="slideshow__form-wrapper" onSubmit={handleSubmit}>
          <h2 className="slideshow-h2">Generator Pixeli</h2>

          <input
            className="pixel-generator__file-input"
            type="file"
            accept={PIXEL_ACCEPT}
            onChange={(event) => setFile(event.target.files?.[0] || null)}
          />

          <div className="slideshow-flex-row">
            <InputTextSlide
              placeholder="Campaign ID"
              value={formData.campaignId}
              text="Campaign ID: "
              name="campaignId"
              handleChange={handleChange}
            />
            <InputTextSlide
              placeholder="Creative ID"
              value={formData.creativeId}
              text="Creative ID: "
              name="creativeId"
              handleChange={handleChange}
            />
          </div>

          <InputTextSlide
            placeholder="Pixel Column Name"
            value={formData.pixelColumnName}
            text="Pixel Column Name: "
            name="pixelColumnName"
            handleChange={handleChange}
          />

          <div className="pixel-generator__actions">
            <Button txt="Generuj" type="submit" styles={{ backgroundColor: "black" }} />
          </div>

          {info ? (
            <p
              className={`pixel-generator__status ${
                infoType === "error"
                  ? "pixel-generator__status--error"
                  : "pixel-generator__status--success"
              }`}
            >
              {info}
            </p>
          ) : null}
        </form>
      </div>
    </>
  );
};

export default PixelGenerator;
